var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { markRaw, createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  width: "1em",
  height: "1em",
  viewBox: "0 0 120 88",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _hoisted_2 = ["fill"], _hoisted_3 = ["fill"], _hoisted_4 = ["fill"], _hoisted_5 = ["fill"], _hoisted_6 = ["fill"], _hoisted_7 = ["id"], _hoisted_8 = ["id"], _hoisted_9 = ["id"], _hoisted_10 = ["id"], _hoisted_11 = ["id"];
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, [
    createElementVNode("path", {
      d: "M62.999 52.0332C83.6897 52.4933 100 57.6752 100 64C100 70.6274 82.0914 76 60 76C37.9086 76 20 70.6274 20 64C20 57.6753 36.3098 52.4934 57 52.0332C57.0178 53.6748 58.3542 55 60 55C61.6458 55 62.9812 53.6748 62.999 52.0332Z",
      fill: "url(#" + _ctx.idMap.paint0_linear_9004_55255 + ")"
    }, null, 8, _hoisted_2),
    createElementVNode("ellipse", {
      cx: "35",
      cy: "49",
      rx: "12",
      ry: "4",
      fill: "url(#" + _ctx.idMap.paint1_linear_9004_55255 + ")"
    }, null, 8, _hoisted_3),
    createElementVNode("ellipse", {
      cx: "88",
      cy: "80",
      rx: "9",
      ry: "3",
      fill: "url(#" + _ctx.idMap.paint2_linear_9004_55255 + ")"
    }, null, 8, _hoisted_4),
    _cache[5] || (_cache[5] = createElementVNode("path", {
      d: "M79 28C82.3137 28 85 30.6863 85 34V58C85 61.3137 82.3137 64 79 64H41C37.6863 64 35 61.3137 35 58V34C35 30.6863 37.6863 28 41 28H79ZM60 37C56.6863 37 54 39.6863 54 43C54 45.2205 55.2071 47.1578 57 48.1953V52C57 53.6569 58.3431 55 60 55C61.6569 55 63 53.6569 63 52V48.1953C64.7929 47.1578 66 45.2205 66 43C66 39.6863 63.3137 37 60 37Z",
      fill: "#E3E8FF"
    }, null, -1)),
    createElementVNode("path", {
      d: "M79 28C82.3137 28 85 30.6863 85 34V58C85 61.3137 82.3137 64 79 64H41C37.6863 64 35 61.3137 35 58V34C35 30.6863 37.6863 28 41 28H79ZM60 37C56.6863 37 54 39.6863 54 43C54 45.2205 55.2071 47.1578 57 48.1953V52C57 53.6569 58.3431 55 60 55C61.6569 55 63 53.6569 63 52V48.1953C64.7929 47.1578 66 45.2205 66 43C66 39.6863 63.3137 37 60 37Z",
      fill: "url(#" + _ctx.idMap.paint3_linear_9004_55255 + ")"
    }, null, 8, _hoisted_5),
    _cache[6] || (_cache[6] = createElementVNode("path", {
      d: "M60 10C68.8366 10 76 17.1634 76 26V28H66V26C66 22.6863 63.3137 20 60 20C56.6863 20 54 22.6863 54 26V28H44V26C44 17.1634 51.1634 10 60 10Z",
      fill: "black"
    }, null, -1)),
    createElementVNode("path", {
      d: "M60 10C68.8366 10 76 17.1634 76 26V28H66V26C66 22.6863 63.3137 20 60 20C56.6863 20 54 22.6863 54 26V28H44V26C44 17.1634 51.1634 10 60 10Z",
      fill: "url(#" + _ctx.idMap.paint4_linear_9004_55255 + ")"
    }, null, 8, _hoisted_6),
    createElementVNode("defs", null, [
      createElementVNode("linearGradient", {
        id: _ctx.idMap.paint0_linear_9004_55255,
        x1: "60",
        y1: "52",
        x2: "60",
        y2: "76",
        gradientUnits: "userSpaceOnUse"
      }, _cache[0] || (_cache[0] = [
        createElementVNode("stop", { "stop-color": "#C7D0FD" }, null, -1),
        createElementVNode("stop", {
          offset: "1",
          "stop-color": "#EFF2FD"
        }, null, -1)
      ]), 8, _hoisted_7),
      createElementVNode("linearGradient", {
        id: _ctx.idMap.paint1_linear_9004_55255,
        x1: "35",
        y1: "45",
        x2: "35",
        y2: "53",
        gradientUnits: "userSpaceOnUse"
      }, _cache[1] || (_cache[1] = [
        createElementVNode("stop", { "stop-color": "#C7D0FD" }, null, -1),
        createElementVNode("stop", {
          offset: "1",
          "stop-color": "#EFF2FD"
        }, null, -1)
      ]), 8, _hoisted_8),
      createElementVNode("linearGradient", {
        id: _ctx.idMap.paint2_linear_9004_55255,
        x1: "88",
        y1: "77",
        x2: "88",
        y2: "83",
        gradientUnits: "userSpaceOnUse"
      }, _cache[2] || (_cache[2] = [
        createElementVNode("stop", { "stop-color": "#C7D0FD" }, null, -1),
        createElementVNode("stop", {
          offset: "1",
          "stop-color": "#EFF2FD"
        }, null, -1)
      ]), 8, _hoisted_9),
      createElementVNode("linearGradient", {
        id: _ctx.idMap.paint3_linear_9004_55255,
        x1: "60",
        y1: "28",
        x2: "60",
        y2: "64",
        gradientUnits: "userSpaceOnUse"
      }, _cache[3] || (_cache[3] = [
        createElementVNode("stop", { "stop-color": "#5B63D2" }, null, -1),
        createElementVNode("stop", {
          offset: "1",
          "stop-color": "#C7D0FD"
        }, null, -1)
      ]), 8, _hoisted_10),
      createElementVNode("linearGradient", {
        id: _ctx.idMap.paint4_linear_9004_55255,
        x1: "60",
        y1: "10",
        x2: "60",
        y2: "28",
        gradientUnits: "userSpaceOnUse"
      }, _cache[4] || (_cache[4] = [
        createElementVNode("stop", { "stop-color": "#5B63D2" }, null, -1),
        createElementVNode("stop", {
          offset: "1",
          "stop-color": "#C7D0FD"
        }, null, -1)
      ]), 8, _hoisted_11)
    ])
  ]);
}
__name(render, "render");
const noAvailable = markRaw({ name: "custom-color-noAvailable", render, setup() {
  const __randId = /* @__PURE__ */ __name(() => Math.random().toString(36).substr(2, 10), "__randId");
  return { idMap: { paint0_linear_9004_55255: "uicons-" + __randId(), paint1_linear_9004_55255: "uicons-" + __randId(), paint2_linear_9004_55255: "uicons-" + __randId(), paint3_linear_9004_55255: "uicons-" + __randId(), paint4_linear_9004_55255: "uicons-" + __randId() } };
} });
export {
  noAvailable as default
};
//# sourceMappingURL=noAvailable.js.map
